import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateAsAgoPipe } from './date-as-ago.pipe';
import { CapitalizeFirstLetterPipe } from './capitalize-first-letter.pipe';
import { CommaSeparatedPipe } from './priceFormatter';



@NgModule({
  declarations: [
    DateAsAgoPipe,
    CapitalizeFirstLetterPipe,
    CommaSeparatedPipe
  ],
  imports: [
    CommonModule
  ],
  exports:[
    DateAsAgoPipe,
    CapitalizeFirstLetterPipe,
    CommaSeparatedPipe
  ]
})
export class PipeModule { }
